import Foot from '../Components/Footer/footer';
import Games from '../Components/Game/games';
import Head from '../Components/Header/header';
function Gamepage(){
return(
<>

<Head/>
<Games/>
<Foot/>
</>
)
}
export default Gamepage;